/* Avella Organics theme.js */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var val = (cents / 100).toFixed(2);
    var parts = val.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    var noDecimals = parts[0];
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
  };

  var toast = function (msg) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); }, 2200);
  };

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('[data-burger]');
  var mnav = document.querySelector('[data-mobile-nav]');
  if (burger && mnav) {
    burger.addEventListener('click', function () { mnav.classList.add('is-open'); });
    mnav.querySelectorAll('[data-mobile-close]').forEach(function (b) {
      b.addEventListener('click', function () { mnav.classList.remove('is-open'); });
    });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: document.querySelector('[data-drawer]'),
    overlay: document.querySelector('[data-drawer-overlay]'),
    body: document.querySelector('[data-drawer-body]'),
    total: document.querySelector('[data-drawer-total]'),
    count: document.querySelectorAll('[data-cart-count]'),
    threshold: parseInt((document.body.getAttribute('data-free-shipping') || '0'), 10),
    open: function () { document.body.classList.add('drawer-open'); },
    close: function () { document.body.classList.remove('drawer-open'); },
    fetch: function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    },
    render: function (cart) {
           if (!this.body) return;

      /* ---- Savings: original price per line + "You save" in the footer ---- */
      var self = this;
      var cmp = self._cmp || (self._cmp = {});
      var missing = [];
      cart.items.forEach(function (it) {
        if (!(it.variant_id in cmp) && it.handle && missing.indexOf(it.handle) < 0) missing.push(it.handle);
      });
      if (missing.length && !self._cmpLoading) {
        self._cmpLoading = true;
        Promise.all(missing.map(function (h) {
          return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (p) { (p.variants || []).forEach(function (v) { cmp[v.id] = v.compare_at_price || 0; }); })
            .catch(function () {});
        })).then(function () {
          cart.items.forEach(function (it) { if (!(it.variant_id in cmp)) cmp[it.variant_id] = 0; });
          self._cmpLoading = false;
          self.render(cart);
        });
      }
      var wasLine = function (it) {
        var unit = Math.max(
          it.original_price || 0,
          (it.selling_plan_allocation && it.selling_plan_allocation.compare_at_price) || 0,
          cmp[it.variant_id] || 0
        );
        return unit * it.quantity;
      };
      var wasTotal = 0;
      cart.items.forEach(function (it) { wasTotal += wasLine(it); });
      var saved = Math.max(0, wasTotal - cart.total_price);
      if (this.total) {
        var totalRow = this.total.closest('.drawer__total') || this.total.parentNode;
        var savedRow = totalRow.parentNode.querySelector('[data-drawer-saved]');
        if (!savedRow) {
          savedRow = document.createElement('div');
          savedRow.className = 'drawer__saved';
          savedRow.setAttribute('data-drawer-saved', '');
          totalRow.parentNode.insertBefore(savedRow, totalRow);
        }
        savedRow.innerHTML = '<span>You save</span><span>' + money(saved) + '</span>';
        savedRow.hidden = saved <= 0;
      }
      this.count.forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-count', cart.item_count); });
      if (this.total) this.total.textContent = money(cart.total_price);
      if (!cart.items.length) {
        this.body.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn btn--outline" href="' + (window.theme.shopUrl || '/') + '">Continue shopping</a></div>';
        document.dispatchEvent(new CustomEvent('cart:rendered', { detail: cart }));
        return;
      }
      var html = '';
      if (this.threshold > 0) {
        var remaining = Math.max(0, this.threshold - cart.total_price);
        var pct = Math.min(100, Math.round((cart.total_price / this.threshold) * 100));
        html += '<div class="ship-bar">' + (remaining > 0 ? 'You are <strong>' + money(remaining) + '</strong> away from free shipping.' : '<strong>You unlocked free shipping.</strong>') +
          '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
      }
      cart.items.forEach(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2') : '';
        html += '<div class="ci" data-key="' + it.key + '">' +
          '<img src="' + img + '" alt="">' +
          '<div><div class="ci__title">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="ci__var">' + it.variant_title + '</div>' : '') +
          (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? '<div class="ci__var">' + it.selling_plan_allocation.selling_plan.name + '</div>' : '') +
          '<div class="ci__row"><div class="qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>' +
                    '<span class="ci__price">' + (wasLine(it) > it.final_line_price ? '<s>' + money(wasLine(it)) + '</s>' : '') + '<strong>' + money(it.final_line_price) + '</strong></span></div>' +
          '<button type="button" class="ci__remove" data-remove>Remove</button></div></div>';
      });
      this.body.innerHTML = html;
      document.dispatchEvent(new CustomEvent('cart:rendered', { detail: cart }));
    },
    change: function (key, qty) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); });
    },
    add: function (formData, giftId) {
      var self = this;
      return fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) { toast(res.description || 'Could not add to cart'); return; }
          return self.fetch().then(function (cart) {
            // Free gift: add 1 soap bar if it is not already in the cart
            var hasGift = giftId && cart.items.some(function (it) { return String(it.variant_id) === String(giftId); });
            if (!giftId || hasGift) return cart;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(giftId), quantity: 1 }] })
            }).then(function () { return self.fetch(); }).catch(function () { return cart; });
          }).then(function (cart) { self.render(cart); self.open(); });
        });
    },
    init: function () {
      var self = this;
      if (!this.drawer) return;
      document.querySelectorAll('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); self.fetch().then(function (c) { self.render(c); self.open(); }); });
      });
      document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      this.body.addEventListener('click', function (e) {
        var ci = e.target.closest('.ci'); if (!ci) return;
        var key = ci.getAttribute('data-key');
        var qtyEl = ci.querySelector('.qty span');
        var qty = parseInt(qtyEl.textContent, 10);
        if (e.target.matches('[data-qty]')) self.change(key, Math.max(0, qty + parseInt(e.target.getAttribute('data-qty'), 10)));
        if (e.target.matches('[data-remove]')) self.change(key, 0);
      });
      this.fetch().then(function (c) { self.render(c); });
    }
  };
  Cart.init();


  /* ---------- Cart reservation timer ---------- */
  var timerEl = document.querySelector('[data-cart-timer]');
  if (timerEl) {
    var clockEl = timerEl.querySelector('[data-cart-timer-clock]');
    var mins = parseInt(timerEl.getAttribute('data-minutes') || '10', 10);
    var KEY = 'avella_cart_timer_end';
    var getEnd = function () { try { return parseInt(sessionStorage.getItem(KEY) || '0', 10); } catch (e) { return 0; } };
    var setEnd = function (v) { try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} };
    var ensure = function (hasItems) {
      if (!hasItems) { timerEl.hidden = true; return; }
      timerEl.hidden = false;
      if (!getEnd() || getEnd() < Date.now()) setEnd(Date.now() + mins * 60000);
    };
    var tick = function () {
      if (timerEl.hidden) return;
      var left = Math.max(0, getEnd() - Date.now());
      var m = Math.floor(left / 60000), sec = Math.floor((left % 60000) / 1000);
      clockEl.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
      timerEl.classList.toggle('is-expired', left === 0);
    };
    document.addEventListener('cart:rendered', function (e) { ensure(e.detail && e.detail.item_count > 0); tick(); });
    setInterval(tick, 1000);
  }

  /* ---------- Selling plan helpers ---------- */
  // Variant + selling plan prices printed by main-product.liquid
  var getPrices = function (form) {
    if (form._prices) return form._prices;
    var el = form.querySelector('[data-variant-prices]');
    try { form._prices = JSON.parse(el ? el.textContent : '{}') || {}; } catch (e) { form._prices = {}; }
    return form._prices;
  };
  // Subscribe is on when the app has any selling plan set. Each pack can have its own plan
  // (e.g. 1 jar monthly, 3 jars every 2 months), so map the app's plan to the selected variant's plan.
  var resolvePlan = function (prices, variantId, sellingPlanId) {
    if (!sellingPlanId) return null;
    var v = prices[String(variantId)];
    if (!v || !v.plans) return null;
    if (v.plans[sellingPlanId]) return { id: String(sellingPlanId), price: v.plans[sellingPlanId].price, compare: v.plans[sellingPlanId].compare };
    var ids = Object.keys(v.plans);
    if (!ids.length) return null;
    return { id: ids[0], price: v.plans[ids[0]].price, compare: v.plans[ids[0]].compare };
  };

  /* ---------- Product forms (AJAX) ---------- */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn ? btn.querySelector('[data-btn-text]') : null;
      var original = label ? label.textContent : '';
      if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding…'; }
      var fd = new FormData(form);
      var sp = fd.get('selling_plan');
      if (sp) {
        var plan = resolvePlan(getPrices(form), fd.get('id'), String(sp));
        if (plan) fd.set('selling_plan', plan.id);
      }
      // Packs 2 and 3 (2nd and 3rd option) get the free soap bar
      var GIFT_VARIANT_ID = '51962441662710';
      var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="id"]'));
      var picked = form.querySelector('input[name="id"]:checked');
      var giftId = radios.indexOf(picked) >= 1 ? GIFT_VARIANT_ID : null;
      Cart.add(fd, giftId).finally(function () {
        if (btn) { btn.disabled = false; if (label) label.textContent = original; }
      });
    });
  });

  /* ---------- Price sync: pack + subscription (Kaching selling plan) ---------- */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    var wrap = form.querySelector('[data-packs]');
    var priceOut = form.querySelector('[data-btn-price]');
    var stickyOut = document.querySelector('[data-sticky-price]');
    var prices = getPrices(form);

    var checkedRadio = function () {
      return form.querySelector('input[name="id"]:checked') || form.querySelector('[name="id"]');
    };

    // Kaching adds a selling_plan field to the form. Read it whatever shape it takes
    // (hidden input, radio, checkbox or select). Empty or disabled = one time purchase.
    var sellingPlan = function () {
      var els = Array.prototype.slice.call(form.querySelectorAll('[name="selling_plan"]'));
      if (form.id) {
        els = els.concat(Array.prototype.slice.call(document.querySelectorAll('[name="selling_plan"][form="' + form.id + '"]')));
      }
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.disabled) continue;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
        if (el.value) return String(el.value);
      }
      return '';
    };

    // Swap each pack's price to the subscription price while subscribe is selected
    var renderPacks = function (sp) {
      if (!wrap) return;
      wrap.querySelectorAll('.pack').forEach(function (pack) {
        var input = pack.querySelector('input[name="id"]');
        var box = pack.querySelector('.pack__price');
        if (!input || !box) return;
        if (box._original == null) box._original = box.innerHTML;
        var v = prices[String(input.value)];
        var plan = resolvePlan(prices, input.value, sp);
        if (!plan) { if (box.innerHTML !== box._original) box.innerHTML = box._original; return; }
        var units = parseInt(input.getAttribute('data-units') || '1', 10) || 1;
        var was = Math.max(v.price, v.compare || 0, plan.compare || 0);
        var html = (was > plan.price ? '<span class="pack__was">' + money(was) + '</span>' : '') +
          '<span class="pack__now">' + money(plan.price) + '</span>' +
          '<span class="pack__per">' + money(Math.floor(plan.price / units)) + ' per ' + (input.getAttribute('data-unit-label') || 'jar') + '</span>';
        if (box.innerHTML !== html) box.innerHTML = html;
      });
    };

    var last = null;
    var render = function () {
      var radio = checkedRadio();
      if (wrap) {
        wrap.querySelectorAll('.pack').forEach(function (p) { p.classList.toggle('is-selected', !!radio && p.contains(radio)); });
      }
      var vid = radio ? String(radio.value) : '';
      var sp = sellingPlan();
      var key = vid + '|' + sp;
      if (key === last) return;
      last = key;

      var v = prices[vid];
      var base = v ? v.price : parseInt((radio && radio.getAttribute('data-price')) || '0', 10);
      var now = base;
      var was = 0;
      var plan = resolvePlan(prices, vid, sp);
      if (plan) {
        now = plan.price;
        was = Math.max(base, (v && v.compare) || 0, plan.compare || 0);
        if (was <= now) was = 0;
      }
      // Keep ?variant= in the URL in sync so the subscription app knows which pack is selected
      if (vid && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          if (u.searchParams.get('variant') !== vid) { u.searchParams.set('variant', vid); history.replaceState(history.state, '', u.toString()); }
        } catch (e) {}
      }
      var html = (was ? '<s class="btn__was">' + money(was) + '</s> ' : '') + money(now);
      if (priceOut) priceOut.innerHTML = html;
      if (stickyOut) stickyOut.innerHTML = html;
      renderPacks(sp);
    };

    var schedule = function () {
      if (window.requestAnimationFrame) requestAnimationFrame(render);
      setTimeout(render, 80);
    };
    form.addEventListener('change', schedule);
    form.addEventListener('click', schedule);
    form.addEventListener('input', schedule);
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(form, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['value', 'checked', 'disabled', 'name']
      });
    }
    // Safety net: Kaching can set the hidden input value via JS without firing events
    setInterval(render, 400);
    render();

    /* Hide the price and the "Deliver every" box inside the subscription app widget.
       Matched by content, not by app class names, so it survives app updates. */
    var hidePrice = form.getAttribute('data-hide-app-price') === 'true';
    var hideFreq = form.getAttribute('data-hide-app-frequency') === 'true';
    if (hidePrice || hideFreq) {
      var MONEY_RE = /[$€£]\s?\d[\d,]*(?:\.\d{2})?|\d[\d,]*(?:\.\d{2})?\s?(?:USD|CAD|AED|EUR|GBP)/gi;
      var hide = function (el) {
        if (el && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
      };
      var onlyMoney = function (el) {
        var t = (el.textContent || '').replace(MONEY_RE, '').replace(/[\s\u00a0]+/g, '');
        return t === '' && new RegExp(MONEY_RE.source, 'i').test(el.textContent || '');
      };
      var scan = function (root, stop) {
        if (!root) return;
        if (hidePrice) {
          root.querySelectorAll('*').forEach(function (el) {
            if (el.children.length || !onlyMoney(el)) return;
            var top = el;
            while (top.parentElement && top.parentElement !== stop && top.parentElement !== root && onlyMoney(top.parentElement)) top = top.parentElement;
            hide(top);
          });
        }
        if (hideFreq) {
          root.querySelectorAll('*').forEach(function (el) {
            if (el.children.length > 3) return;
            var txt = (el.textContent || '').trim();
            if (!/^deliver(y)? every/i.test(txt)) return;
            var top = el;
            while (top.parentElement && top.parentElement !== stop && top.parentElement !== root &&
                   (top.parentElement.textContent || '').trim() === txt) top = top.parentElement;
            hide(top);
          });
        }
        root.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) scan(el.shadowRoot, null); });
      };
      var runHide = function () {
        form.querySelectorAll('.app-block').forEach(function (b) { scan(b, b); });
      };
      runHide();
      if (window.MutationObserver) {
        new MutationObserver(function () { setTimeout(runHide, 30); })
          .observe(form, { subtree: true, childList: true, characterData: true });
      }
      setInterval(runHide, 1000);
    }
  });

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = Array.prototype.slice.call(g.querySelectorAll('.pg__slide'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.pg__thumb'));
    var dots = Array.prototype.slice.call(g.querySelectorAll('.pg__dot'));
    var main = g.querySelector('.pg__main');
    var count = g.querySelector('[data-pg-count]');
    var idx = 0;
    var mobile = function () { return window.matchMedia('(max-width: 960px)').matches; };
    var set = function (i, scroll) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      if (count) count.textContent = (idx + 1) + '/' + slides.length;
      if (scroll && mobile() && main) main.scrollTo({ left: main.clientWidth * idx, behavior: 'smooth' });
    };
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { set(n, true); }); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { set(n, true); }); });
    var prev = g.querySelector('.pg__arrow--prev'), next = g.querySelector('.pg__arrow--next');
    if (prev) prev.addEventListener('click', function () { set(idx - 1, true); });
    if (next) next.addEventListener('click', function () { set(idx + 1, true); });
    if (main) {
      var raf;
      main.addEventListener('scroll', function () {
        if (!mobile()) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth);
          if (i !== idx) set(i, false);
        });
      });
    }
    set(0, false);
  });

  /* ---------- Countdown (resets at local midnight) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var tick = function () {
      var now = new Date();
      var end = new Date(now); end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      el.textContent = h + ':' + (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Reviews: load more ---------- */
  document.querySelectorAll('[data-review-list]').forEach(function (list) {
    var step = parseInt(list.getAttribute('data-step') || '5', 10);
    var items = Array.prototype.slice.call(list.querySelectorAll('.rv'));
    var btn = list.parentElement.querySelector('[data-load-more]');
    var shown = 0;
    var show = function () {
      items.slice(shown, shown + step).forEach(function (i) { i.hidden = false; });
      shown = Math.min(items.length, shown + step);
      if (btn) btn.hidden = shown >= items.length;
    };
    items.forEach(function (i) { i.hidden = true; });
    show();
    if (btn) btn.addEventListener('click', show);
    list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-helpful]'); if (!b || b.disabled) return;
      var n = b.querySelector('span'); if (n) n.textContent = parseInt(n.textContent, 10) + 1; b.disabled = true;
    });
  });

  /* ---------- Sticky "add to cart" mobile bar ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var buyBox = document.querySelector('[data-buy-box]');
  if (sticky && buyBox) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(buyBox);
    sticky.addEventListener('click', function () { buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }
})();
